<!--积分规则-->
<template>
  <div class="qmyx-container">
    <div class="body">
      <div class="body-list" v-for="item in ruleList" :key="item.id">
        <div class="body-list-left">
          <div class="body-list-left-total">{{ item.configName }}</div>
          <div class="body-list-left-explain">积分说明：{{ item.remark }}</div>
        </div>
        <div class="body-list-right">{{ item.pointsConfig }}</div>
      </div>
    </div>
  </div>
</template>
<script>
// import { getAgent } from "../../api";
import { getrules } from "../api";
export default {
  data() {
    return {
      ruleList: []
    };
  },
  activated() {
    this.getAgent();
  },
  methods: {
    async getAgent() {
      // const data = await getAgent();
      const status = 10; //默认写死
      const ruleObj = await getrules(status);
      console.log("ruleObj data", ruleObj);
      if (ruleObj.body.result.length > 0) {
        this.ruleList = ruleObj.body.result;
      }
    },
    async getrules() {
      const data = await getrules();
      console.log("getpoints", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  padding: 0 0.32rem 0 0.32rem;
}
.body-list {
  padding: 0.34rem 0 0.3rem 0;
  border-bottom: 0.02rem solid rgba(244, 244, 244, 1);
}
.body-list-left {
  display: inline-block;
}
.body-list-right {
  display: inline-block;
  float: right;
  margin-top: 0.16rem;
  height: 100%;
  font-size: 0.28rem;
  font-weight: 500;
  color: rgba(240, 123, 36, 1);
}
.body-list-left-total {
  font-size: 0.32rem;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}
.body-list-left-explain {
  font-size: 0.24rem;
  font-weight: 450;
  color: rgba(153, 153, 153, 1);
  margin-top: 0.14rem;
}
</style>
